"use client";
import { FC } from "react";
import { CHAR_LIMITS, textEllipsis } from "./clpCardConstant";
import { PriceChangeProps } from "./types";

export const PriceChange: FC<PriceChangeProps> = ({
  changePrice,
  perChange,
  className = "",
}) => {
  const combined = `${changePrice} (${Number(perChange).toFixed(2)}%)`;
  return (
    <p className={`text-[12px] text-gray-600 ${className}`.trim()}>
      {textEllipsis(
        combined,
        CHAR_LIMITS.TOTAL_CHANGE_INFO,
        "stock-change-info",
      )}
    </p>
  );
};

